const DEEP_LINK_QUERIES = {
  GENERAL: {
    NAME: 'general.name',
    TITLE: 'general.htmlTitle',
    SLUG: 'general.slug',
    META_DESCRIPTION: 'general.metaDescription'
  },
  IMAGE: {
    FEATURED_IMAGE: 'image.featuredImage'
  },
  TEMPLATE: {},
  LANG_AND_REGION: {
    LANGUAGE: 'langAndRegion.language'
  },
  ROLE_AND_ACCESS: {
    PASSWORD: 'roleAndAccess.password'
  },
  ADVANCED: {
    DYNAMIC_PAGES: 'advanced.dynamicPages'
  }
};
export default DEEP_LINK_QUERIES;